// Slider arrows for owl slider
var darrow  = ['<svg xmlns="http://www.w3.org/2000/svg" width="17.844" height="30.35" viewBox="0 0 17.844 30.35"><defs><style>.cls-1 {fill: #fff;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="cls-1" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg>' , '<svg xmlns="http://www.w3.org/2000/svg" width="17.85" height="30.343" viewBox="0 0 17.85 30.343"><defs><style>.cls-1 {fill: #fff;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="cls-1" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg>'];
var darrow2 = ['<svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 17.844 30.35"><defs><style>.darrow2-cls-1 {fill: #fff;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="darrow2-cls-1" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg>' , '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 17.85 30.343"><defs><style>.darrow2-cls-1 {fill: #fff;fill-rule: evenodd}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="darrow2-cls-1" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg>'];
var darrow3  = ['<svg xmlns="http://www.w3.org/2000/svg" width="17.844" height="30.35" viewBox="0 0 17.844 30.35"><defs><style>.arrow-class {}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="arrow-class" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg>' , '<svg xmlns="http://www.w3.org/2000/svg" width="17.85" height="30.343" viewBox="0 0 17.85 30.343"><defs><style>.arrow-class {}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="arrow-class" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg>'];
var griddarrow  = ['<svg xmlns="http://www.w3.org/2000/svg" width="17.844" height="30.35" viewBox="0 0 17.844 30.35"><defs><style>.cls-1 {fill: #b2b2b2;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="cls-1" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg>' , '<svg xmlns="http://www.w3.org/2000/svg" width="17.85" height="30.343" viewBox="0 0 17.85 30.343"><defs><style>.cls-1 {fill: #b2b2b2;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="cls-1" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg>'];
var darrow4  = [
    '<span aria-label="Previous" role="presentation"> <svg xmlns="http://www.w3.org/2000/svg" width="17.844" height="30.35" viewBox="0 0 17.844 30.35"><defs><style>.cls-1 {fill: #fff;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="cls-1" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg> </span>',
    '<span aria-label="Next" role="presentation"> <svg xmlns="http://www.w3.org/2000/svg" width="17.85" height="30.343" viewBox="0 0 17.85 30.343"><defs><style>.cls-1 {fill: #fff;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="cls-1" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg> </span>',
];
var darrow5  = [
    '<span aria-label="Previous" role="presentation" > <svg xmlns="http://www.w3.org/2000/svg" width="11" height="20" viewBox="0 0 17.844 30.35"><defs><style>.arrow-class {}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="arrow-class" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg> </span> <span class="btn-text">Prev</span>',
    '<span class="btn-text">Next</span><span aria-label="Next" role="presentation"> <svg xmlns="http://www.w3.org/2000/svg" width="11" height="20" viewBox="0 0 17.85 30.343"><defs><style>.arrow-class {}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="arrow-class" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg> </span> ',
];

$(window).on('load', function(){

    // Tabs slider call why baros
    tabsSLiderWhyBaros();

    //room types
    homeRoomTypesCarousels();
    // isElementInViewport('.hm-room-types', homeRoomTypesCarousels);

    //Offers
    offersSlider();
    // isElementInViewport('.offers-wrap', offersSlider);

    //Things to do
    thingsToDo();
    // isElementInViewport('.hm-things-do', thingsToDo);

    //why boook with video init
    // whyBookWithVideoInit();
    // isElementInViewport('#why_book_video_1', faqslider);


    
  
});

function isElementInViewport (el, methodCallBack) {
            
    var carouselSection = [].slice.call(document.querySelectorAll(el));

    if ("IntersectionObserver" in window) {
      let lazyElementObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            methodCallBack();
            entry.target.classList.add("visible");
            lazyElementObserver.unobserve(entry.target);
          }
        });
      });
  
      carouselSection.forEach(function(lazyBackground) {
        lazyElementObserver.observe(lazyBackground);
      });
    }else{
        methodCallBack();
    }
}



/* Why baros tabs slider  */
function tabsSLiderWhyBaros() {
    var args = {
        items : 1,
        dots: false,
        nav: true,
        smartSpeed: 200,
        // navText : darrow,
        navText : darrow4,
        slideSpeed: 500,
        lazyLoad:true,
        lazyLoadEager: 1,
        responsive: {
            0: {
                items:1
            },
            768: {
                items:2 
            },
            992: {
                items :3
            },
            1200: {
                items: 4,
                touchDrag  : true,
                mouseDrag  : true
            }
        }
    } 
    $('.tabs-slider').owlCarousel(args).on('changed.owl.carousel', function(e) {
        showHideTabs(e.item.index);
    });
}


function thingsToDo(){
    var thingstodo = {
        items : 1,
        margin: 5,
        dots: false,
        nav: !1,
        navText : darrow3,
        lazyLoad:true,
        lazyLoadEager: 1,
        responsive: {
            0: {
                nav: !1,
            },
            768: {
                nav:  !0,
                dots: !1
            },
            1200: {
                nav:  !0,
                dots: !1
            },
        }
    } 

    if($('.things-to-slider').length){
        $('.things-to-slider').owlCarousel(thingstodo);
    }
}



function offersSlider(){
    var args = {
        items: 1,
        autoplay: 0,
        margin:1,
        loop: !0,
        dots:false,
        navText: griddarrow,
        lazyLoad:true,
        lazyLoadEager: 1,
        responsive :{
            0 :{
                dots: 1,
            },
            768:{
              items:2,
              margin:25,
              dots:false,
              nav:true,
            //   stagePadding: 150,
            },
            992:{
                dots:false,
                nav:true,
                items:2,
                margin:30,
                // stagePadding: 80,
            },
            1340:{
                dots:false,
                nav:true,
                items:3,
                margin: 25,
                stagePadding: 0,
            },
            1600:{
                dots:false,
                nav:true,
                items:3 ,
                margin:30,
            },
        }
    }
    $('.offers-slider').owlCarousel(args);
}

/**
 * Home room types carousels
 */
function homeRoomTypesCarousels(){
    var homeRoomTypesSliderArgs = {
        items : 1,
        dots: false,
        nav: true,
        margin: 0,
        smartSpeed: 200,
        // navText : darrow3,
        navText : darrow5,
        slideSpeed : 500,
        loop: true,
        mouseDrag: false,
        pullDrag: false,
        lazyLoad:true,
        lazyLoadEager: 1,
        // onResized: outofnumber,
        // onRefreshed: outofnumber,
        // onInitialized: outofnumber,
        // onChanged: outofnumber,
    } 

    if($('.hm-room-types-main-carousel').length){
        $('.hm-room-types-main-carousel').owlCarousel(homeRoomTypesSliderArgs);
    }
}

function whyBookWithVideoInit(){

    var optionsSinglePlayer = {
        autoplay: true,
        loop: true,
    };

    if($('#why_book_video_1').length){
        singleVideoPlayer = videojs(
            "why_book_video_1",
            optionsSinglePlayer);
    }
}

$('.tabs-slider .item').on('click', function (e) {
    e.preventDefault();
    var currentItem = $(this).data('hash');
    showHideTabs(currentItem);
});


/* out of number */
function outofnumber(event) {

    if (!event.namespace) {
        return;
    }
    var carousel = event.relatedTarget;
    var count = carousel.relative(carousel.current()) + 1;
    var itemlength = carousel.items().length;
    var setItemLength   =   '';
    var countLength     =   '';
    
    if ( itemlength >= 10 ){
        setItemLength   =   itemlength;
    }else{
        setItemLength   =    addLeadingZeros(itemlength);
    }

    if ( count >= 10 ){
        countLength =   count;
    }else{
        countLength =   addLeadingZeros(count);
    }

    // $(event.target).parent().find('.owl-dots').html('<span class="activecount">' + countLength + '</span>' + '/' + setItemLength );

    

    var numbers_html_block = '<div class="total-nav-container">'+ 
                                '<div class="nav-text-header"> Villa Category </div>' + 
                                '<div class="nav-text-count"> <span class="activecount"> ' + countLength + '</span> of <span class="totalcount"> ' + setItemLength + '</span> </div>' + 
                            '</div>'
    $('.hm-room-types-main-carousel > .owl-dots').html(numbers_html_block);
}

/* add leading zero */
function addLeadingZeros(value) {
    if (value != null) {
        return ('0' + value.toString()).slice(-value.length);
    }
}



function showHideTabs(num) {
    $('.tab-wrapper-slide').hide();
    $('.video-slider-wrapper .tab-wrapper-slide').each(function (index, value) {
        if ( num == $(this).data('id') ) {
            $(this).show();
        }
    });

    var itemsList = $('.tabs-slider .item');
    $('.item-inner').removeClass('active');
    itemsList.each(function (index, value) {
        if ( num == index ) {
            $(this).find('.item-inner').addClass('active');
        }
    });
}



//date format pure js
function appendLeadingZeroes(n) {
    if (n <= 9) {
        return "0" + n;
    }
    return n;
}
